/* eslint-disable no-unused-vars */
let WHStockUpdateMsg_KEY = "WHStockUpdateMsg_1"
let WHStockUpdateHisMsg_KEY = "WHStockUpdateHisMsg_1"
let WHStockUpdateThreadMsg_KEY = "WHStockUpdateThreadMsg_1"
let loginWebsocketTimestemp_key = "loginWebsocketTimestempKey"

export function saveLocalStorLogin(data, _obj_this) {
  localStorage.setItem(loginWebsocketTimestemp_key, data.websocketTimestemp)
}

export function getLocalStorWebsocketTimestemp(_obj_this) {
  let lsKey = loginWebsocketTimestemp_key;
  let v = localStorage.getItem(lsKey) ? localStorage.getItem(lsKey) : 0
  return v
}
export function cleanLocalStorWebsocketTimestemp(_obj_this) {
  let lsKey = loginWebsocketTimestemp_key;
  localStorage.setItem(lsKey,'')
  localStorage.removeItem(lsKey);
}

/**
 * 保存库存更新进度
 * @param {*} listData 
 * @param {*} _obj_this 
 */
export function saveLocalStorWHStockUpdateMsgList(listData, _obj_this) {
  localStorage.setItem(WHStockUpdateMsg_KEY, JSON.stringify(listData))
}
export function saveLocalStorWHStockUpdateHisMsgList(listData, _obj_this) {
  localStorage.setItem(WHStockUpdateHisMsg_KEY, JSON.stringify(listData))
}
export function saveLocalStorWHStockUpdateThreadMsgList(listData, _obj_this) {
  const obj = {}
  listData.forEach((v, k) => (obj[k] = v))
  const JsonStr = JSON.stringify(obj)
  localStorage.setItem(WHStockUpdateThreadMsg_KEY, JsonStr)
}
/**
 * 获取库存更新进度
 * @param {*} _obj_this 
 */
export function getLocalStorWHStockUpdateMsgList(_obj_this) {
  let lsKey = WHStockUpdateMsg_KEY;
  let list = localStorage.getItem(lsKey) ? JSON.parse(localStorage.getItem(lsKey)) : []
  return list
}
export function getLocalStorWHStockUpdateHisMsgList(_obj_this) {
  let lsKey = WHStockUpdateHisMsg_KEY;
  let list = localStorage.getItem(lsKey) ? JSON.parse(localStorage.getItem(lsKey)) : []
  return list
}
export function getLocalStorWHStockUpdateThreadMsgList(_obj_this) {
  let lsKey = WHStockUpdateThreadMsg_KEY;
  const jsonObj = localStorage.getItem(lsKey) ? JSON.parse(localStorage.getItem(lsKey)) : {}
  const map = new Map()
  for (const k of Object.keys(jsonObj)) {
    map.set(k, jsonObj[k])
  }
  return map
}
/**
 * 清除库存更新进度
 * @param {*} _obj_this 
 */
export function cleanLocalStorWHStockUpdateMsgList(_obj_this) {
  let lsKey = WHStockUpdateMsg_KEY;
  localStorage.setItem(lsKey,'')
  localStorage.removeItem(lsKey);
  let lsHisKey = WHStockUpdateHisMsg_KEY;
  localStorage.setItem(lsHisKey,'')
  localStorage.removeItem(lsHisKey);
}

